import { PulseBaseProvider } from '../../base-classes';
import { getTrafficCamsSchema } from '../schemas/trafficCam';

const _getTrafficCamsCacheKey = 'getTrafficCams';
const _getTrafficCamsUri = '/data/traffic/v2';

const _getTrafficCamStreamCacheKey = 'getTrafficCamStream';
const _getTrafficCamStreamUri = '/data/traffic/v2/{cameraId}/streams';

const _getTrafficCamDetailCacheKey = 'getTrafficCamDetail';
const _getTrafficCamDetailUri = '/data/traffic/v2/{cameraId}';

export class TrafficCamProvider extends PulseBaseProvider {

    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_getTrafficCamsCacheKey] = this.getTrafficCamsSyncer.bind(this);
        this.storage.sync[_getTrafficCamStreamCacheKey] = this.getTrafficCamStreamSyncer.bind(this);
        this.storage.sync[_getTrafficCamDetailCacheKey] = this.getTrafficCamDetailSyncer.bind(this);
    }

    async getTrafficCamsSyncer(params) {
        const {
            id,
            syncParams,
            resolve,
            reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            location: syncParams.location,
            locationType: syncParams.locationType,
            radius: syncParams.radius,
            maxCount: syncParams.maxCount,
            verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getTrafficCamsUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , !syncParams.verbose ? getTrafficCamsSchema : null
        );
    }

    async getTrafficCams(location, locationType = 'latitudelongitude', radius = 804670, maxCount = 20, stdParameters, verbose = false, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            location,
            locationType,
            radius,
            maxCount,
            refresh
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getTrafficCamsCacheKey, id);
        }
        return await super.loadFromStorage(_getTrafficCamsCacheKey, id, syncParams);
    }

    async getTrafficCamStreamSyncer(params) {
        const {
            id,
            syncParams,
            resolve,
            reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getTrafficCamStreamUri.replace('{cameraId}', syncParams.cameraId)
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getTrafficCamStream(cameraId, stdParameters, verbose = false, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            cameraId,
            refresh
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getTrafficCamStreamCacheKey, id);
        }
        return await super.loadFromStorage(_getTrafficCamStreamCacheKey, id, syncParams);
    }

    async getTrafficCamDetailSyncer(params) {
        const {
            id,
            syncParams,
            resolve,
            reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getTrafficCamDetailUri.replace('{cameraId}', syncParams.cameraId)
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getTrafficCamDetail(cameraId, stdParameters, verbose = false, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            cameraId,
            refresh
        };

        const id = JSON.stringify(syncParams);
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getTrafficCamDetailCacheKey, id);
        }
        return await super.loadFromStorage(_getTrafficCamDetailCacheKey, id, syncParams);
    }
}
